import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const WestVirginia = () => {
  return (
    <StatePropertyTaxPage
      stateName="West Virginia"
      processDescription="Property owners may appeal their assessment by filing with the county commission within 30 days of receiving notice. Appeals should include evidence supporting the property owner's claimed true and actual value."
      noticeOfValueMailed="April"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in April following annual assessments."
      valuationAsOfDate="July 1"
      valuationAsOfDateExplanation="West Virginia assesses property as of July 1 of the prior year. This mid-year assessment date captures property values during the active summer real estate season."
      deadlineExplanation="Property owners have 30 days from receiving notice to file appeals with the county commission. This typically results in a May deadline."
    />
  );
};

export default WestVirginia;